// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Utils
import { getInvestmentInfoDates } from '../../../../utils/disclaimers/comparison';
import { formatMessageWithLocale } from '../../../../utils/i18n';
import { DISCLAIMER_KEYS } from '../../../../utils/disclaimers/constants';
import { getPreferredDataProvider, getDataProviderName } from '@/utils/users';

// Types and Enums
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';
import User from '@/types/user';

interface Props {
  items: ComparisonItem[];
  locale?: Locale;
  showItemNames?: boolean;
  user?: User;
}

const EquityOtherMetricsDisclaimer = ({ items, locale, showItemNames, user }: Props) => {
  const equityItems = items.filter(
    i =>
      !!i.disclaimers &&
      (!i.disclaimers[DISCLAIMER_KEYS.FUND_EQUITY_METRICS_NOT_APPLICABLE] || !i.disclaimers[DISCLAIMER_KEYS.PORTFOLIO_EQUITY_METRICS_NOT_APPLICABLE]),
  );

  const preferredDataKeys = ['fundPortfolio.investmentInfo.peRatio', 'fundPortfolio.investmentInfo.pbRatio'];
  const hasPreferredDataProvider = user && preferredDataKeys.map(key => getPreferredDataProvider(user, key)).find(Boolean);

  const disclaimerText = hasPreferredDataProvider
    ? formatMessageWithLocale('Disclaimers.EquityOtherMetricsWithDataProvider', locale, {
        preferredDataProvider:
          getDataProviderName(user, 'fundPortfolio.investmentInfo.peRatio') || getDataProviderName(user, 'fundPortfolio.investmentInfo.pbRatio'),
      })
    : formatMessageWithLocale('Disclaimers.EquityOtherMetrics', locale);

  return (
    <DatesDisclaimer
      globalPrefix={disclaimerText}
      itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
      itemDates={getInvestmentInfoDates(equityItems, locale)}
      showItemNames={showItemNames}
      locale={locale}
    />
  );
};

export default EquityOtherMetricsDisclaimer;
